import React, { useState,useRef, useEffect } from 'react'
import './patientdetails.css'
import { fetchPatientPrimaryDetails, registerPatient, Store_formData, fetch_consultationNow,updatepatientinfo } from "../../../../actions/InterBranchCoordinatorAction"
import { useSelector, useDispatch } from "react-redux";
import { Form, Input, Radio, Modal } from 'antd';

import checkImage from '../../../../assets/InterBranch/PNGIcons/check.png'
import { useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import { PulseLoader } from 'react-spinners';
import CustomPhoneInputV2 from '../../../CustomPhoneInputV2/CustomPhoneInputV2';
import { INTERBRANCH_CLEAR_TEMP_APPOINTMENT_FORM,CLEAR_INTERBRANCH_DATA, INTERBRANCH_MODAL_UPDATE, INTERBRANCH_UPDATE_TEMP_APPOINTMENT_FORM } from '../../../../actions/type';
import { checkUser } from '../../../../actions/SignupAction';
import { SimpleCloseIconRed } from '../../../../assets/Logos/Icons';

function PatientDetail({ isSchedule, resumevisible, consultationId,consultationdata }) {


    let dispatch = useDispatch();
    let history = useHistory()
    const location = useLocation();
    let { path, url } = useRouteMatch();
    let signupData = location.state;
    let clinicId = useSelector((state) => state?.login?.user?.clinicId);
    let reduxData = useSelector(state => state);
    //Destructuring data from redux........................................
    let { patientName, patientNumber, patientHospitalId, gender, aadhaarNumber, emergencyContactName, emergencyContactNumber, emailID, } = useSelector(state => state?.interBranchCoordinator?.appointment_form)

    let appointment_form = useSelector(state => state?.interBranchCoordinator?.appointment_form)
    let temp_appointment_form = useSelector(state => state?.interBranchCoordinator?.temp_appointment_form)

    const [form] = Form.useForm();

    let [isAadhaar, setAadhar] = useState(false);

    let [aadharNumber, setAadhaarNumber] = useState(null);
    let [startVerify, setStartVerify] = useState(false);
    let [alreadyRegisterd, setAlreadyRegisterd] = useState(false);
    
    // Initialize mobile as string format expected by the verification logic
    const initialMobileString = patientNumber?.dialCOde && patientNumber?.number 
        ? `%2B${patientNumber.dialCOde} ${patientNumber.number}` 
        : null;
    let [mobile, setMobile] = useState(initialMobileString);
    let [isMobileVerified, setMobileVerified] = useState(false)
    let [isMobileChanged, setMobileChanged] = useState(false)
    let [isdisabled, setIsdisabled] = useState(false)

    let [mobileWithDiallCode, setMobileWithDialCode] = useState(patientNumber);
    let [isFilled, setFilled] = useState(false);

    let [emergencyContactNumberWithDialcode, setEmergencyContactNumber] = useState()

    let [isSaving, setSaving] = useState(false)

    let [mobileOtp, setMobileOtp] = useState(null)

    const [actualOTP, setActualOTP] = useState(null);
    
    // Consultation popup state
    const [consultationPopupVisible, setConsultationPopupVisible] = useState(false);
    const [consultationData, setConsultationData] = useState(consultationdata);
    const [hasOngoingConsultation, setHasOngoingConsultation] = useState(false);
    const [popupShown, setPopupShown] = useState(false);
    const [cancelclicked, setCancelclicked] = useState(false);
    const [scheduleMenu, setScheduleMenu] = useState( url.includes("scheduleappointment"));
    const MINUTE_MS = 10000;
    const popupShownRef = useRef(false);
 function consultationnow() {
    if (isSchedule) return;

    try {
        const userDetails = JSON.parse(localStorage.getItem("userData"));
        const userId = userDetails.profileId;

        dispatch(fetch_consultationNow(userId)).then((data) => {
            if (data.data.appointmentId !== undefined) {
                setConsultationData({
                    appointmentId: data.data.appointmentId,
                    PatientName: data.data.PatientName || "Patient",
                    doctorName: data.data.doctorName || "Doctor",
                    patientAge: data.data.patientAge || "",
                    patientGender: data.data.patientGender || ""
                });

                setHasOngoingConsultation(true);

                // Only show popup once
                if (!popupShownRef.current) {
                    setConsultationPopupVisible(true);
                    popupShownRef.current = true;
                }
            } else {
                setConsultationPopupVisible(false);
                setConsultationData(null);
                setHasOngoingConsultation(false);
                popupShownRef.current = false; // reset when consultation ends
                setCancelclicked(false);
            }
        });
    } catch (error) {
        console.log("Error in fetch_consultationNow API", error);
    }
}


useEffect(() => {
    if (!scheduleMenu) {
      consultationnow();

      const interval = setInterval(() => {
        consultationnow();
      }, MINUTE_MS);

      return () => clearInterval(interval);
    }
  }, [scheduleMenu]);


useEffect(() => {
        if (signupData != undefined && signupData.appointmentId != undefined) {
          if (signupData.page === "prescripton") {
            dispatch({ type: CLEAR_INTERBRANCH_DATA });
          }
        } else {
         
        }
      }, [signupData]);

    useEffect(() => {

        if (patientName || patientNumber || gender) {
            setFilled(true)
        }

        loadDefaultValues()
        
        // Restore mobile number state if it exists in Redux
        if (patientNumber?.dialCOde && patientNumber?.number) {
            const mobileString = `%2B${patientNumber.dialCOde} ${patientNumber.number}`;
            setMobile(mobileString);
            setMobileWithDialCode(patientNumber);
            console.log("✅ Restored mobile number:", mobileString);
        }
        
        // Initialize temp_appointment_form from appointment_form if not already set
        if (!temp_appointment_form && appointment_form) {
            dispatch({
                type: INTERBRANCH_UPDATE_TEMP_APPOINTMENT_FORM,
                payload: appointment_form
            });
            console.log("✅ Initialized temp_appointment_form from appointment_form");
        }


    }, [])


    useEffect(() => {

        form.setFieldsValue({
            aadhaarNumber,
            emergencyContactName,
            emergencyContactNumber: emergencyContactNumber?.number,
            patientHospitalId,
            patientName,
            patientNumber: patientNumber?.number,
            gender,
            emailID
        })

    }, [appointment_form])

    // Trigger validation when form data changes
    useEffect(() => {
        const isFormValid = isreadyToSubmit();
        setFilled(isFormValid);
    }, [emergencyContactNumberWithDialcode, isMobileVerified, patientName, gender, mobileWithDiallCode])

   


    //Functions............................................................


    let handleAadhaarOnChange = (e) => {

        handleChangeFormItem({ key: "aadhaarNumber", value: e.target.value })

        setAadhaarNumber(e.target.value);
        setStartVerify(false);
        setAadhar(false);
        form.setFieldsValue({ aadhaarNumber: e.target.value.replace(/\D/g, "") })
    }


    const checkOTP = (mobNumber) => {
        // console.log("Mobile Number: ",mobNumber)

        try {
            dispatch(
                checkUser({
                    searchtype: "Mobile",
                    searchKey: mobNumber
                })
            )
                .then((res) => {
                    console.log("Info:", res)
                    if (res?.info) {
                        let resValue = res?.info;
                        //setActualOTP(resValue)
                        setActualOTP("7890");

                    }
                })
        } catch (error) {
            //console.log("Error in OTP generating API", error);
        }
    }

    const onFinish = (values) => {
        console.info('=== FORM SUBMISSION STARTED ===');
        console.info('Form values:', values);
        console.info('Current state:', {
            isSaving,
            hasOngoingConsultation,
            cancelclicked,
            isMobileVerified,
            isMobileChanged,
            alreadyRegisterd,
            isdisabled,
            mobileWithDiallCode,
            temp_appointment_form
        });

        // Prevent multiple submissions while saving
        if (isSaving) {
            console.warn('❌ Form submission blocked: Already saving');
            return;
        }
        console.log('✅ Passed: Not currently saving');

        // Check if there's an ongoing consultation
        if (hasOngoingConsultation && !cancelclicked) {
            console.warn('❌ Form submission blocked: Ongoing consultation detected');
            // Show the consultation popup instead of silently blocking
            setConsultationPopupVisible(true);
            return;
        }
        console.log('✅ Passed: No ongoing consultation blocking');

        // Check if mobile is verified before allowing submission
        // Only require verification if mobile number was changed or if it's a new patient
        if (!isMobileVerified && (isMobileChanged || !alreadyRegisterd)) {
            console.warn('❌ Form submission blocked: Mobile verification required');
            console.log('Verification check details:', {
                isMobileVerified,
                isMobileChanged,
                alreadyRegisterd,
                verificationRequired: isMobileChanged || !alreadyRegisterd
            });
            dispatch({
                type: INTERBRANCH_MODAL_UPDATE,
                payload: { modalName: "commomAlertModal", isVisible: true, data: "Please verify your mobile number before proceeding." }
            })
            return;
        }
        console.log('✅ Passed: Mobile verification check');

        // Emergency contact validation is currently disabled
        // if (emergencyContactNumberWithDialcode?.number == mobileWithDiallCode.number) {
        //     dispatch({
        //         type: INTERBRANCH_MODAL_UPDATE,
        //         payload: { modalName: "commomAlertModal", isVisible: true, data: "Please enter different emergency contact number." }
        //     })
        //     return;
        // }

        // Proceed with submission
        {
            console.log('✅ Passed: All validation checks, proceeding with submission');

            let submissionData = {
                aadhaarNumber: values.aadhaarNumber,
                emergencyContactName: values.emergencyContactName,
                patientHospitalId: values.patientHospitalId,
                patientName: values.patientName,
                gender: values.gender,
                emailID: values.emailID,
                isPatientNumberVerified: isMobileVerified,

                emergencyContactNumber: temp_appointment_form?.emergencyContactNumber,
                patientNumber: temp_appointment_form?.patientNumber,
            }

            console.log('📤 Submission data prepared:', submissionData);
            console.log('📤 Redux data:', reduxData.interBranchCoordinator.appointment_form);

            setSaving(true)
            console.log('🔄 Starting Store_formData dispatch...');
            
            dispatch(
                Store_formData({
                    ...reduxData.interBranchCoordinator.appointment_form,
                    ...submissionData,
                })
            ).then((res) => {
                console.log('✅ Store_formData successful:', res);
                if(alreadyRegisterd){   
                    setSaving(false)
                    dispatch(updatepatientinfo(clinicId,localStorage.getItem("PatientId"), submissionData))
                        .then((res) => {
                            console.log(res)
                            dispatch(
                                fetchPatientPrimaryDetails({
                                    searchtype: "Mobile",
                                    searchKey: "%2B" + mobile,
                                    appointment_form: temp_appointment_form
                                })
                            )
                                .then((res) => {
                                    console.info("Info:", res)
                                    console.info("Form:", temp_appointment_form)
                                    // Parse emergency number properly
                                    let emergencyNumber = res?.emergencynumber;
                                    let emergencyNumberObj = null;
                                    
                                    if (emergencyNumber) {
                                        // Handle different formats of emergency number
                                        if (emergencyNumber.includes(' ')) {
                                            const parts = emergencyNumber.split(' ');
                                            emergencyNumberObj = {
                                                number: parts[1] || parts[0],
                                                countryCode: parts[0] || '91',
                                                dialCOde: parts[0] || '+91',
                                                numberWithCode: emergencyNumber
                                            };
                                        } else {
                                            // If no space, assume it's just the number
                                            emergencyNumberObj = {
                                                number: emergencyNumber,
                                                countryCode: '91',
                                                dialCOde: '+91',
                                                numberWithCode: '+91 ' + emergencyNumber
                                            };
                                        }
                                    }

                                    form.setFieldsValue({
                                        patientName: res?.fullname,
                                        patientHospitalId: res?.hospitalid,
                                        emailID: res?.emailID,
                                        emergencyContactName: res?.emergencyname,
                                        emergencyContactNumber: emergencyNumberObj?.number,
                                        aadhaarNumber: res?.aadharnumber,
                                        gender: res?.gender
                                    })

                                    // Update emergency contact number state
                                    if (emergencyNumberObj) {
                                        setEmergencyContactNumber(emergencyNumberObj);
                                    }
                                
                            })
                         
                        })
                        .catch((error) => {
                           
                        });
                    history.push(`/dashboard/${url.includes("bookandconsult") ? "bookandconsult" : "scheduleappointment"}/choosedoctor`)

                }else
                {
                    
                    dispatch(registerPatient(clinicId, submissionData))
                        .then((res) => {
                            console.log(res)
                            setSaving(false)
                            if (res.data.info != 'Failed') {
                                localStorage.setItem("PatientId", res.data.info)
                            }

                            history.push(`/dashboard/${url.includes("bookandconsult") ? "bookandconsult" : "scheduleappointment"}/choosedoctor`)

                        })
                        .catch((error) => {
                            console.log("Error in registerPatient:", error);
                            setSaving(false);
                        });
                }
            })
            .catch((error) => {
                console.error("❌ Error in Store_formData:", error);
                setSaving(false);
            });

        }


    };


    const onFinishFailed = (errorInfo) => {
        //console.log('Failed:', errorInfo);
    };

    const onValuesChange = (values, allValues) => {

        dispatch({
            type: INTERBRANCH_UPDATE_TEMP_APPOINTMENT_FORM,
            payload: {
                ...values,
                patientNumber: mobileWithDiallCode,
                emergencyContactNumber: emergencyContactNumberWithDialcode
            }
        })

        // Trigger validation after a short delay to ensure state updates are complete
        setTimeout(() => {
            const isFormValid = isreadyToSubmit();
            setFilled(isFormValid);
        }, 100);

    }

    let validateLettersOnly = (event) => {

        // //console.log( event.which );

        if (event.which === 46 || event.which === 8 || event.which === 32) {

        }

        else if ((event.which < 65 || event.which > 90)) {
            event.preventDefault();
        }


    }

    let validateEmailId = (e) => {
        if (e.key.match(new RegExp("/^[a-zA-Z0-9]+@+[a-zA-Z0-9]+.+[A-z]/"))) {
        }
        else {
            e.preventDefault();
        }
    }


    let renderPhoneValidation = () => {




    }


    let startMobileNumberVerification = (mobile) => {
        checkOTP("%2B" + mobile);
        setMobileChanged(false)
        setStartVerify(true)
    }

    let verifyMobileNumber = async (mobile) => {


        form.validateFields(["patientNumberOTP"])
            .then((res) => {
                console.info("responsee",res)
                if (res && res.patientNumberOTP) {
                     console.info("************ddd",res)
                        setStartVerify(false)
                        setMobileVerified(true);
                        form.setFieldsValue({ patientNumberOTP: null })
                        try {
                            dispatch(
                                fetchPatientPrimaryDetails({
                                    searchtype: "Mobile",
                                    searchKey: "%2B" + mobile,
                                    appointment_form: temp_appointment_form
                                })
                            )
                                .then((res) => {
                                    console.log("Info:", res)
                                    console.log("Form:", temp_appointment_form)
                                    if(res.isNewPatient){

                                    }else{
                                    setAlreadyRegisterd(true)
                                    localStorage.setItem("PatientId", res.patientId)
                                    // form.resetFields(["emergencyContactNumber", "emergencyContactName", "aadhaarNumber", "patientHospitalId", "emailID"]); 

                                    // Parse emergency number properly
                                    let emergencyNumber = res?.emergencynumber;
                                    let emergencyNumberObj = null;
                                    
                                    if (emergencyNumber) {
                                        // Handle different formats of emergency number
                                        if (emergencyNumber.includes(' ')) {
                                            const parts = emergencyNumber.split(' ');
                                            emergencyNumberObj = {
                                                number: parts[1] || parts[0],
                                                countryCode: parts[0] || '91',
                                                dialCOde: parts[0] || '+91',
                                                numberWithCode: emergencyNumber
                                            };
                                        } else {
                                            // If no space, assume it's just the number
                                            emergencyNumberObj = {
                                                number: emergencyNumber,
                                                countryCode: '91',
                                                dialCOde: '+91',
                                                numberWithCode: '+91 ' + emergencyNumber
                                            };
                                        }
                                    }

                                    form.setFieldsValue({
                                        patientName: res?.fullname,
                                        patientHospitalId: res?.hospitalid,
                                        emailID: res?.emailID,
                                        emergencyContactName: res?.emergencyname,
                                        emergencyContactNumber: emergencyNumberObj?.number,
                                        aadhaarNumber: res?.aadharnumber,
                                        gender: res?.gender
                                    })

                                    // Update emergency contact number state
                                    if (emergencyNumberObj) {
                                        setEmergencyContactNumber(emergencyNumberObj);
                                    }
                                    
                                    // Trigger validation after setting all form values
                                    setTimeout(() => {
                                        const isFormValid = isreadyToSubmit();
                                        setFilled(isFormValid);
                                    }, 100);
                                }

                                })
                        } catch (error) {
                            console.log("Error in fetching patient's primary details API", error);
                        }

                    

                }else
                {
                    setMobileVerified(true)
                    // Trigger validation after mobile verification
                    setTimeout(() => {
                        const isFormValid = isreadyToSubmit();
                        setFilled(isFormValid);
                    }, 100);
                }
            })


    }

    let handleChangeFormItem = ({ key, value }) => {
        // Update the form field value
        form.setFieldsValue({ [key]: value });
        
        // Trigger validation after state update
        setTimeout(() => {
            const isFormValid = isreadyToSubmit();
            setFilled(isFormValid);
        }, 100);
    }

   

    // Handle join consultation from popup
    const handleJoinConsultation = () => {
        if (consultationData?.appointmentId) {
            setConsultationPopupVisible(false);
            setPopupShown(false);
            // history.push(`/meetdr/${consultationData.appointmentId}`);
            history.push(`/meetspoke/${consultationData.appointmentId}`);
        }
    };

    // Handle cancel consultation popup
    const handleCancelConsultation = () => {
        setConsultationPopupVisible(false);
         setCancelclicked(true)
         popupShownRef.current = false;
        // Don't reset popupShown so popup won't show again after cancel
    };

    function allowOnlyNumericsOrDigits(e) {
        !["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Backspace"].includes(e.key) && e.preventDefault()
    }


    let isreadyToSubmit = () => {

        let formNumber = form.getFieldValue("patientNumber")
        let formName = form.getFieldValue("patientName")
        let formGender = form.getFieldValue("gender")
        
        // Check if patient name is provided
        const isNameValid = (patientName || formName) && (patientName || formName).trim().length > 0;
        
        // Check if gender is selected
        const isGenderValid = (gender || formGender);
        
        // Check if mobile number is provided and valid
        const cleanMobileNumber = mobileWithDiallCode?.number?.trim();
        const isMobileNumberValid = (cleanMobileNumber && cleanMobileNumber.length >= 6 && cleanMobileNumber.length <= 15);
        
        // Additional check: ensure mobile number is not just spaces or empty and contains only digits
        const isMobileNotEmpty = cleanMobileNumber && cleanMobileNumber.length > 0 && /^\d+$/.test(cleanMobileNumber);
        
        console.log("Validation check:", {
            isNameValid,
            isGenderValid,
            isMobileNumberValid,
            isMobileNotEmpty,
            cleanMobileNumber,
            formNumber,
            formName,
            formGender,
            mobileWithDiallCode,
            patientName,
            gender
        });
        
        // Button should be enabled when basic required fields are valid
        const isFormValid = isNameValid && isGenderValid && isMobileNumberValid && isMobileNotEmpty;
        console.info("Form validation result:", isFormValid)
        setIsdisabled(isFormValid);
        
        return isFormValid;
    }


    const loadDefaultValues = () => {

        // Preserve mobile verification status if it was already verified
        if (appointment_form?.isPatientNumberVerified) {
            setMobileVerified(true);
            console.log("✅ Restored mobile verification status from Redux");
        }
        
        // Restore patient registration status if patient ID exists
        const savedPatientId = localStorage.getItem("PatientId");
        if (savedPatientId && savedPatientId !== 'undefined' && savedPatientId !== 'null') {
            setAlreadyRegisterd(true);
            console.log("✅ Restored patient registration status from localStorage");
        }
        
        // Restore emergency contact number if it exists
        if (appointment_form?.emergencyContactNumber) {
            setEmergencyContactNumber(appointment_form.emergencyContactNumber);
        }
        
        setMobileChanged(false)


    }


    const parseEmergencyNumber = (emergencyNumber) => {
  if (!emergencyNumber) return null;

  let number = emergencyNumber.trim();
  let countryCode = '91';
  let dialCode = '+91';

  // Remove leading +91 or 91 with optional spaces/hyphens
  if (/^\+?91[\s-]?/.test(number)) {
    number = number.replace(/^\+?91[\s-]?/, '').trim();
  }

  return {
    number, // clean 10-digit number
    countryCode,
    dialCode,
    numberWithCode: `${dialCode} ${number}`,
  };
};

    const populatePatientFormFromPrimaryDetails = (res) => {
        const emergencyNumberObj = parseEmergencyNumber(res?.emergencynumber);
        form.setFieldsValue({
            patientName: res?.fullname,
            patientHospitalId: res?.hospitalid,
            emailID: res?.emailID,
            emergencyContactName: res?.emergencyname,
            emergencyContactNumber: emergencyNumberObj?.number,
            aadhaarNumber: res?.aadharnumber,
            gender: res?.gender
        });
        if (emergencyNumberObj) {
            setEmergencyContactNumber(emergencyNumberObj);
        }
    };

    const handlePhoneNumberOnChange = ({ number, value, data, event }) => {

        setMobileOtp("")
        setFilled(false)
        // Extract the number part more carefully
        let extractedNumber = value;
        if (data.dialCode && value) {
            // Remove the dial code from the beginning of the value
            const dialCodePattern = data.dialCode.replace(/[+()\s-]/g, ''); // Remove special chars
            const valueWithoutSpecialChars = value.replace(/[+()\s-]/g, '');
            
            if (valueWithoutSpecialChars.startsWith(dialCodePattern)) {
                extractedNumber = valueWithoutSpecialChars.substring(dialCodePattern.length);
            } else {
                // Fallback to original method
                extractedNumber = value?.slice(data.dialCode.length).trim();
            }
        }
        
        setMobileWithDialCode(
            {
                dialCOde: data.dialCode,
                number: extractedNumber?.trim(),
                countryCode: data.countryCode,
                numberWithCode: value

            })


        if (extractedNumber && extractedNumber.trim().length > 0) {
            setMobile(value);
        }
        else {
            setMobile(null);
        }

        // Removed OTP verification check - no longer reset verification status on number change
        setMobileChanged(false)

        dispatch(
            fetchPatientPrimaryDetails({
                searchtype: "Mobile",
                searchKey: "%2B" + data?.dialCode +" "+ ( extractedNumber || ''),
                appointment_form: temp_appointment_form
            })
        ).then((res) => {
            // Always set mobile as verified when we get a response from the API
            setMobileVerified(true);
            if (res.isNewPatient) {
                form.setFieldsValue({
                    patientName: undefined,
                    patientHospitalId: undefined,
                    emailID: undefined,
                    emergencyContactName: undefined,
                    emergencyContactNumber: undefined,
                    aadhaarNumber: undefined,
                    gender: undefined
                });
                setAlreadyRegisterd(false)
            } else {
                setAlreadyRegisterd(true)
                setMobileVerified(true);
                localStorage.setItem("PatientId", res.patientId)
                populatePatientFormFromPrimaryDetails(res);
                isreadyToSubmit()
            }
        }).catch((error) => {
            console.log("Error in fetchPatientPrimaryDetails:", error);
            // Even if there's an error, we can still allow the user to proceed
            // as the mobile number might be valid but not in our system
            setMobileVerified(true);
        })

        // Trigger validation after state updates
        setTimeout(() => {
            const isFormValid = isreadyToSubmit();
            setFilled(isFormValid); 
        }, 100);

    }

    const handlePhoneNumberOnBlur = ({ value, data, event }) => {

        handleChangeFormItem({
            key: "patientNumber",
            value:
            {
                dialCOde: data?.dialCode,
                number: value?.slice(data.dialCode.length),
                countryCode: data.countryCode,
                numberWithCode: value

            }
        })

    }


console.info("isdisabled",isdisabled)
    return (
        <>
        <div className='patient-details-container'>

            <div className="tittle">

                <div className="details-item mandatory">

                    <div className="caption-mandatory"> <span className="red">*</span>  Mandatory</div>

                </div>
            </div>



            <Form
                form={form}
                name="basic"
                labelCol={{
                    span: 8,
                }}
                wrapperCol={{
                    span: 16,
                }}
                initialValues={{
                    remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={(errorInfo) => {
                    console.error('❌ Form validation failed:', errorInfo);
                    onFinishFailed(errorInfo);
                }}
                onValuesChange={onValuesChange}
                autoComplete="off"
            >
                <div className="details-item mandatory contact-number">

                    <div className="caption">Patient Mobile Number <div className="red">*</div></div>
                    <div className="input-item ">

                        <Form.Item

                            name="patientNumber"
                            // initialValue={patientNumber?.number}
                            rules={[
                                { min: 6, message: 'The mobile number should be minimum 6 digits' },
                                { max: 12, message: 'The mobile number should be maximum 12 digits' },
                                {
                                    required: true,
                                    message: "*Patient mobile number can't be empty",
                                }

                            ]}

                        >

                            <CustomPhoneInputV2
                                key={patientNumber?.number || 'empty'}
                                defaultCountryCode={patientNumber?.countryCode || "91"}
                                defaultvalue={patientNumber?.number || ""}
                                name="patientNumber"
                                //onBlur={(value, data, event) => { handlePhoneNumberOnBlur({ value, data, event }) }}
                                onChange={(number, value, data, event) => { handlePhoneNumberOnChange({ number, value, data, event }) }}
                                placeholder={"Enter Mobile Number"}
                               // disabled={hasOngoingConsultation}
                            />


                            
                        </Form.Item>

                        <div className="verify-aadhaar" style={{display:"none"}}>


                            {
                                ((mobile && !isMobileVerified && !startVerify) || isMobileChanged && mobile) ?

                                    <div 
                                        className="verify-btn" 
                                        onClick={() => startMobileNumberVerification(mobile)}
                                    >
                                        VERIFY
                                    </div>

                                    : (mobile && !isMobileVerified && startVerify) ?

                                        <div className="otp-container">



                                            <div className="otp-container-row">


                                                <Form.Item

                                                    name="patientNumberOTP"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "*OTP can't be empty",
                                                        }

                                                    ]}

                                                >
                                                    <Input
                                                        controls={false}
                                                        onKeyDown={allowOnlyNumericsOrDigits}
                                                        style={{ width: "100%" }}
                                                        className='input'
                                                        value={mobileOtp}
                                                        onChange={e => setMobileOtp(e.target.value)}
                                                        placeholder='Enter OTP'
                                                        maxLength={5}
                                                    />
                                                </Form.Item>
                                                <button 
                                                    type='button' 
                                                    className='verify-otp-btn' 
                                                    onClick={() => { !hasOngoingConsultation && verifyMobileNumber(mobile) }}
                                                    disabled={hasOngoingConsultation}
                                                    style={{ 
                                                        opacity: hasOngoingConsultation ? 0.5 : 1,
                                                        cursor: hasOngoingConsultation ? 'not-allowed' : 'pointer'
                                                    }}
                                                >
                                                    
                                                    VERIFY OTP
                                                </button>
                                            </div>

                                        </div>

                                        : (mobile && isMobileVerified == "Failed") ?

                                            <div className="couponerror">
                                                <SimpleCloseIconRed />
                                                &nbsp;{"Invalid OTP"}
                                            </div>

                                            : (mobile && isMobileVerified) ?

                                                <div className="couponsuccess">
                                                    <img src={checkImage} alt="" />
                                                    {"Successfully Verified"}
                                                </div> : ""


                            }

                        </div>


                    </div>


                </div>

                <div className="details-item mandatory">

                    <div className="caption">Patient Name <div className="red">*</div></div>
                    <div className="input-item ">
                        <Form.Item
                            name="patientName"
                            initialValue={patientName}
                            rules={[
                                {
                                    required: true,
                                    message: "*Patient name can't be empty",
                                },
                                {
                                    pattern: new RegExp("^[a-zA-Z_ ]+$"),
                                    message: "Enter only Alphabets"
                                }
                            ]}
                        >
                            <Input
                                onKeyDown={validateLettersOnly}
                                onChange={(e) => { handleChangeFormItem({ key: "patientName", value: e.target.value }) }}
                                style={{ width: "100%" }} className='input' placeholder="Enter Patient Name" maxLength={45}/>
                        </Form.Item>
                    </div>


                </div>



                <div className="details-item mandatory">

                    <div className="caption">Gender<div className="red">*</div></div>
                    <div className="input-item"></div>
                    <Form.Item
                        name="gender"
                        initialValue={gender}
                        rules={[
                            {
                                required: true,
                                message: "*Choose the gender",
                            }
                        ]}
                    >

                        <Radio.Group name={gender} value={gender} onChange={(e) => { handleChangeFormItem({ key: "gender", value: e.target.value }) }}>

                            <Radio value={"Male"}>Male</Radio>

                            <Radio value={"Female"}>Female</Radio>

                            <Radio value={"Other"}>Other</Radio>

                        </Radio.Group>
                    </Form.Item>
                </div>

                <div className="details-item">

                    <div className="caption">Email Id</div>
                    <div className="input-item">

                        <Form.Item
                            name="emailID"
                            initialValue={emailID}
                            rules={[
                                {
                                    type: "email",
                                    message: "There seems to be some issue with your email id. Please check",
                                },
                                // {
                                //     pattern: new RegExp("/^[a-zA-Z0-9]+@+[a-zA-Z0-9]+.+[A-z]/"),
                                //     message: "Invalid characters in E-Mail ID"
                                // }                              
                            ]}
                        >
                            <Input
                                placeholder='Enter Email Id'
                                onChange={(e) => { handleChangeFormItem({ key: "emailID", value: e.target.value }) }}
                                style={{ width: "100%" }}
                                // onKeyDown={validateEmailId}
                                maxLength={30}
                                className='input'
                            />

                        </Form.Item>


                    </div>


                </div>

                <div className="details-item">

                    <div className="caption">Hospital Id</div>
                    <div className="input-item">

                        <Form.Item
                            name="patientHospitalId"
                            initialValue={patientHospitalId}
                            rules={[
                                {
                                    required: false,
                                    message: 'Please input your hospital id!',
                                },
                                {
                                    pattern: new RegExp("^[a-zA-Z0-9_ ]+$"),
                                    message: "Enter only letters and numbers"
                                }
                            ]}
                        >
                            <Input
                                placeholder='Enter Hospital Id'
                                onChange={(e) => { handleChangeFormItem({ key: "patientHospitalId", value: e.target.value }) }}
                                style={{ width: "100%" }}
                                maxLength={10}
                                className='input'
                            />

                        </Form.Item>


                    </div>


                </div>
                <div className="details-item mandatory" style={{display:"none"}}>

                    <div className="caption">Emergency Contact Name</div>
                    <div className="input-item ">
                        <Form.Item

                            name="emergencyContactName"
                            initialValue={emergencyContactName}
                            rules={[
                                {
                                    required: false,
                                    message: "Emergency contact name can't be empty",
                                },
                                {
                                    pattern: new RegExp("^[a-zA-Z_ ]+$"),
                                    message: "Enter only Alphabets"
                                }
                            ]}
                        >
                            <Input
                                onKeyDown={validateLettersOnly}
                                onChange={(e) => { handleChangeFormItem({ key: "emergencyContactName", value: e.target.value }) }}
                                style={{ width: "100%" }}
                                className='input'
                                maxLength={45}
                                placeholder="Enter Emergency Contact Name"
                                value={emergencyContactName} />
                            
                        </Form.Item>


                    </div>


                </div>

                <div className="details-item mandatory contact-number" style={{display:"none"}}>

                    <div className="caption">Emergency Mobile Number</div>
                    <div className="input-item ">

                        <Form.Item

                            name="emergencyContactNumber"
                            initialValue={emergencyContactNumber?.number}
                            rules={[
                                {
                                    required: false,
                                    message: "Emergency contact number can't be empty",
                                },
                                
                            ]}
                        >


                            <CustomPhoneInputV2
                                key={emergencyContactNumber?.number || 'emergency-empty'}
                                defaultCountryCode={emergencyContactNumber?.countryCode || "91"}
                                defaultvalue={emergencyContactNumber?.number || ""}
                                name="emergencyContactNumber"  
                                  onChange={(number, value, data, event, formattedValue) => {
                                    console.info("number",number )
                                     console.info(", value, ",value,)
                                      console.info(", , data",data)

                                      const emergencyData = {
                                        dialCOde: data.dialCode,
                                        number: data.number,
                                        countryCode: data.dialCode,
                                        numberWithCode: data.dialCode+" "+data.number
                                    };
                                    setEmergencyContactNumber(emergencyData);

                                    
                                    handleChangeFormItem({ key: "emergencyContactNumber", value: data.number })

                                  }}
                               // onChange={(number, value, data, event) => { handlePhoneNumberOnChange({ number, value, data, event }) }}
                                placeholder={"Enter Mobile Number"}
                               // disabled={hasOngoingConsultation}
                            />

                            

                            
                        </Form.Item>

                    </div>


                </div>


                <button 
                    disabled={!isdisabled || isSaving || hasOngoingConsultation} 
                    type="submit" 
                    className='submt-btn'
                    onClick={(e) => {
                        console.log('🖱️ Submit button clicked!');
                        console.log('Button state:', {
                            isdisabled,
                            isSaving,
                            hasOngoingConsultation,
                            disabled: !isdisabled || isSaving || hasOngoingConsultation
                        });
                    }}
                >


                    {
                        isSaving ?

                            <div className="payment_loader">
                                Saving &nbsp;
                                <div className="loader-container">
                                    <PulseLoader
                                        Style={{ width: 50 }} color="#fff" loading={true} size={10} />
                                </div>
                            </div>

                            :
                            "SAVE & PROCEED"
                    }

                </button>
            </Form>
        </div>
        <Modal
                open={consultationPopupVisible && !cancelclicked && !isSchedule}
                onCancel={handleCancelConsultation}
                footer={null}
                width={460}
                centered
                closable={true}
                maskClosable={false}
                style={{
                    borderRadius: '12px',
                    overflow: 'hidden'
                }}
            >
                <div style={{
                    padding: '24px',
                    textAlign: 'center',
                    fontFamily: 'Arial, sans-serif'
                }}>
                    
                    <div style={{
                        width: '80px',
                        height: '80px',
                        backgroundColor: '#FFF3E0',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 20px',
                        border: '2px solid #FFB74D'
                    }}>
                        <div style={{
                            fontSize: '32px',
                            color: '#1976D2'
                        }}>
                            📹
                        </div>
                    </div>

                    
                    <div style={{
                        marginBottom: '24px'
                    }}>
                        <h2 style={{
                            fontSize: '24px',
                            fontWeight: 'bold',
                            color: '#1976D2',
                            margin: '0 0 8px 0',
                            fontFamily: 'Arial, sans-serif'
                        }}>
                           Patient :  {consultationData?.PatientName || 'Patient'}
                        </h2>
                       
                        <p style={{
                            fontSize: '24px',
                            color: '#666',
                            margin: '8px 0 0 0'
                        }}>
                            Doctor: {consultationData?.doctorName || 'Doctor Name'}
                        </p>
                    </div>

                    
                    <div style={{
                        display: 'flex',
                        gap: '12px',
                        justifyContent: 'center'
                    }}>
                        <button
                            onClick={handleJoinConsultation}
                            style={{
                                backgroundColor: '#1976D2',
                                color: 'white',
                                border: 'none',
                                padding: '12px 24px',
                                borderRadius: '8px',
                                fontSize: '16px',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                minWidth: '120px',
                                transition: 'background-color 0.3s ease'
                            }}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#1565C0'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#1976D2'}
                        >
                            Join Now
                        </button>
                        <button
                            onClick={handleCancelConsultation}
                            style={{
                                backgroundColor: 'white',
                                color: '#666',
                                border: '2px solid #E0E0E0',
                                padding: '12px 24px',
                                borderRadius: '8px',
                                fontSize: '16px',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                minWidth: '120px',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseOver={(e) => {
                                e.target.style.backgroundColor = '#F5F5F5';
                                e.target.style.borderColor = '#BDBDBD';
                            }}
                            onMouseOut={(e) => {
                                e.target.style.backgroundColor = 'white';
                                e.target.style.borderColor = '#E0E0E0';
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </Modal>
            </>
    )
}

export default PatientDetail

